import { render, staticRenderFns } from "./ProductPermissions.vue?vue&type=template&id=1fa42c8d&scoped=true&"
import script from "./ProductPermissions.vue?vue&type=script&lang=js&"
export * from "./ProductPermissions.vue?vue&type=script&lang=js&"
import style0 from "./ProductPermissions.vue?vue&type=style&index=0&id=1fa42c8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa42c8d",
  null
  
)

export default component.exports